import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  createPlan,
  type CreatePlanPayload,
  type CreatePlanResponse,
} from '@/api/planCreation'
import { queryKeys } from '@/lib/queryKeys'

/**
 * React Query hook for creating a new plan
 * @returns Mutation object with mutate, isPending, isError, error, and data
 */
export function useCreatePlan() {
  const queryClient = useQueryClient()

  return useMutation<CreatePlanResponse, Error, CreatePlanPayload>({
    mutationFn: createPlan,
    onSuccess: data => {
      console.log('Plan created successfully:', data)
      // Invalidate assortment plans query to refresh the table
      queryClient.invalidateQueries({ queryKey: ['assortment-plans'] })
      // Invalidate plan search queries to show new plan in search results
      queryClient.invalidateQueries({ queryKey: ['planSearch'] })
      // Invalidate browse queries to refresh the folder view
      queryClient.invalidateQueries({ queryKey: queryKeys.browse.all })
    },
    onError: error => {
      console.error('Failed to create plan:', error)
    },
  })
}
